// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { provideJupyterDesignSystem, jpSwitch } from '@jupyter/web-components';
import { provideReactWrapper } from '@microsoft/fast-react-wrapper';
import React from 'react';
const { wrap } = provideReactWrapper(React, provideJupyterDesignSystem());
export const Switch = wrap(jpSwitch(), { events: { onChange: 'change' } });
// @ts-expect-error unknown property
Switch.displayName = 'Jupyter.Switch';
